<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">افزودن تم</strong>
                <strong v-else>ویرایش تم</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  افزودن
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                 ویرایش
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  انصراف
                </CButton>

                <a :href="$route.fullPath" target="_blank">
                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="dark"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>
              </CCol>
            </CRow>
          </CCardHeader>
          <CRow>

            <CCol col="12">
              <CCardBody>
                <CRow>
                  <CCol col="3">
                    <CInput
                        label="نام تم"

                        v-model="name"
                    />
                  </CCol>

                  <CCol col="3">
                    <CInput
                        label="قیمت"

                        v-model="price"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="قیمت قدیم"

                        v-model="old_price"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="آدرس دمو"

                        v-model="demo_url"
                    />
                  </CCol>
                  <CCol col="3">
                    <CSelect
                        label="وضعیت"
:options="[{label:'فعال',value:1},{label:'غیر فعال',value:0}]"
                        :value.sync="status"
                    />
                  </CCol>
                  <CCol col="3">
                    <treeselect
                        v-model="category_id"
                        :options="categories"
                        :resetSearchOnClose="false"
                        :multiple="true"
                        placeholder="دسته بندی"
                        :normalizer="normalizer_persons"
                    />

                  </CCol>


                  <CCol col="3">
                    <CInput
                        label="نام تم در وردپرس"

                        v-model="theme_name"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInputFile
                        :label="$t('components.image')"
                        custom
                        horizontal
                        ref="file_selector"
                        v-show="false"

                        v-on:change="handleFileUpload"
                    />
                    <CCol col="12" class="text-center" v-on:click="open_file_selector()"
                    >
                      <CImg height="100px"
                            width="100px"
                            v-model="previewImage"
                            v-if="previewImage" :src="previewImage"
                      />
                    </CCol>

                  </CCol>
                  <CCol col="12">
                    <hr>

                    <CRow v-for="(sel,index) in selected_plugin">
                      <CCol col="5">
                        <CSelect
                            :options="plugins"
                            :value.sync="sel.plugin_id"
                            label="پلاگین"
                        />
                      </CCol>
                      <CCol col="5">
                        <CSelect
                            :options="[{label:'الزامی نیست',value:0},{label:'الزامی است',value:1}]"
                            :value.sync="sel.is_need"
                            label="الزامی"
                        />
                      </CCol>
                      <CCol col="2">
                        <CButton outline color="dark" @click="selected_plugin.push({plugin_id:plugins[0].value,is_need:0})">+</CButton>
                        <CButton v-if="selected_plugin.length>1" outline color="dark" @click="selected_plugin.splice(index,1)">-</CButton>
                      </CCol>
                    </CRow>
                    <hr>

                  </CCol>
                  <CCol col="12">
                    <CRow v-for="(sel,index) in properties">
                      <CCol col="2">
                        <CInput
                            v-model="sel.name"
                            label="نام"
                        />
                      </CCol>
                      <CCol col="2">
                        <CSelect
                            :options="[{label:'دیتابیس',value:1},{label:'فایل',value:2}]"
                            :value.sync="sel.type"
                            label="نوع"
                        />
                      </CCol>
                      <CCol col="2">
                        <CInput v-model="sel.key" label="کلید"/>
                      </CCol>
                      <CCol >
                        <CTextarea v-model="sel.placeholder" label="توضیحات"/>
                      </CCol>
                      <CCol >
                        <CTextarea v-model="sel.default_value" label="متن پیشفرض"/>
                      </CCol>

                      <CCol col="2">
                        <CButton outline color="dark" @click="add_properties()">+</CButton>
                        <CButton v-if="properties.length>1" outline color="dark" @click="properties.splice(index,1)">-</CButton>
                      </CCol>
                    </CRow>
                  </CCol>


                </CRow>
                <CRow>


                </CRow>
              </CCardBody>

            </CCol>
            <CCol col="12">

                  <CCard>
                    <CCardHeader>
                      <strong>لیست هاست ها</strong>
                    </CCardHeader>
                    <CCardBody>
                      <CDataTable
                          :items="items"
                          :fields="fields"
                          @row-clicked="table_row_clicked"

                          :items-per-page="10"
                          hover
                          sorter
                          striped
                          border
                          column-filter
                          pagination
                      >
                        <template #row="{item,index}">
                          <td style="text-align: center">
                            <p >{{ index + 1 }}</p>
                          </td>
                        </template>
                        <template #category="{item}">
                          <td style="text-align: center">
                          </td>
                        </template>
                        <template #status="{item}">
                          <td style="text-align: center">
                            <p v-if="item.status==1">فعال</p>
                            <p v-if="item.status==0">غیر فعال</p>
                          </td>
                        </template>

                        <template #operation="{item}">
                          <td>
<!--                            <CIcon @click.native="goSubCategories(item)" class="mr-1 text-success"-->
<!--                                   name="cilApplications"/>-->

<!--                            <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>-->

                            <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                          </td>
                        </template>


                      </CDataTable>
                    </CCardBody>

                  </CCard>

            </CCol>

          </CRow>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';


import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'Login',
  data() {
    return {
plugins:[],
properties:[],
      selected_plugin:[],
      confirm_delete_name: "confirm_brand" + new Date().getTime() + "_" + this.$vnode.tag,
      edit_name:'',
      name: '',
      summary: '',
      price: '',
      old_price: '',
      demo_url:'',
      status:1,
      file:null,
      theme_name: '',
      color: '#ffffff',
      previewImage: '/img/placeholder.png',
      description: '',
      items: [],
      table_clicks:0,
      table_clicks_timer:null,
      categories:[],
      category_id:[],
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'name', label: "نام", _style: 'width:10%'},
        {key: 'category', label: "دسته بندی", _style: 'width:10%;'},
        {key: 'status', label: "وضعیت", _style: 'width:10%;'},

        {key: 'price', label: "قیمت فعلی", _style: 'width:10%;'},
        {key: 'old_price', label:"قیمت قدیم", _style: 'width:10%;'},
        {key: 'template_name', label: "نام تم پردپرس", _style: 'width:10%;'},
        {key: 'demo_url', label: "آدرس دمو", _style: 'width:20%;'},
        {key: 'operation', label: "", filter: false, _style: 'width:10%;'},
      ],
      collapseDuration: 0,
      status_form: 0,
      normalizer_persons(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
    }
  },
  components:{
    Treeselect
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_categories();
    this.get_plugins();
    this.properties = []
    this.add_properties()
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {

  },
  methods: {
    add_properties(){
      var obj = {
        name:'',
        type:1,
        key:'',
        placeholder:'',
        default_value:''
      }
      this.properties.push(obj)
    },
    get_plugins() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.get('/plugins', {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.plugins = self.sort_array([],response.data,"id",'name')
        self.selected_plugin = [{plugin_id:self.plugins[0].value,is_need:0}]
      })
          .catch(function (error) {
            console.log(error);
          });
    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }

    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },

    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.edit_name = item.brandName;
      this.name = item.brandName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = this.$root.base_url+'/'+item.imageName;
      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.get('/themes', {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
          self.items = content_data.map((item, row_id) => {
            return {...item, row_id}
          });


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      this.previewImage = URL.createObjectURL(this.file);
    },
    get_categories() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.get('/template_category', {
        params: {
          // isparent : self.$route.params.cat_id
        },

      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.categories=content_data

        self.get_lists();
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_data() {

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "themes";
      } else {
        url = "EditBrand";
        formData.append('id', this.status_form)
      }

      formData.append('demo_url', this.demo_url);
      formData.append('status', this.status);
      formData.append('file', this.file);
      formData.append('name', this.name);
      formData.append('price', this.price);
      formData.append('old_price', this.old_price);
      formData.append('theme_name', this.theme_name);
      formData.append('category_id', JSON.stringify(this.category_id));
      formData.append('plugins', JSON.stringify(this.selected_plugin));
      formData.append('properties', JSON.stringify(this.properties));
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.name = '';
        self.color = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);
        bus.$emit('close_add_base_modal', 'false');

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBrand";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
